import React from "react";
import { XCircle, ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import {
  DASHBOARD,
  LOGIN,
  VENDOR_DASHBOARD,
} from "../../component/common/Routes/AppRoutes";
import { useSelector } from "react-redux";
import { CUSTOMER_DASHBOARD } from "../../component/common/Routes/CustomerRoutes";

const PaymentCancellation = () => {
  const user = useSelector((state) => state.auth.user);

  const navigate = useNavigate();
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        backgroundColor: "#f0f2f5",
        padding: "20px",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "400px",
          backgroundColor: "white",
          borderRadius: "16px",
          boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            backgroundColor: "#ef4444",
            padding: "30px",
            textAlign: "center",
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              borderRadius: "50%",
              width: "100px",
              height: "100px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              margin: "0 auto 20px",
            }}
          >
            <XCircle size={56} color="#FF6B6B" strokeWidth={2} />
          </div>
          <h1
            style={{
              color: "white",
              fontSize: "24px",
              margin: "0",
            }}
          >
            Payment Cancelled
          </h1>
        </div>

        <div
          style={{
            padding: "25px",
            textAlign: "center",
          }}
        >
          <p
            style={{
              color: "#555",
              marginBottom: "20px",
              lineHeight: "1.6",
            }}
          >
            Your transaction has been cancelled. No charges were processed.
          </p>

          <div
            style={{
              backgroundColor: "#FFF4E5",
              border: "1px solid #FFD699",
              borderRadius: "8px",
              padding: "15px",
              marginBottom: "20px",
            }}
          >
            <p
              style={{
                color: "#FF9900",
                margin: "0",
                fontSize: "14px",
              }}
            >
              <strong>Need assistance?</strong> If this was unintentional,
              please contact our support team.
            </p>
          </div>

          <button
            style={{
              width: "100%",
            }}
            className="cancel-button"
            onClick={() => {
              if (user) {
                let bookingsRoute;

                if (user.role === "Admin" || user.role === "Staff") {
                  bookingsRoute = DASHBOARD;
                } else if (user.role === "Vendor") {
                  bookingsRoute = VENDOR_DASHBOARD;
                } else if (user.role === "Customer") {
                  bookingsRoute = CUSTOMER_DASHBOARD;
                }
                navigate(bookingsRoute);
              } else if (!user) {
                localStorage.removeItem("instantToken");
                navigate(LOGIN);
              }
            }}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancellation;
